import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { hasValue } from '../../../general/js/general-helpers';
import { useScreenDetector } from '../../../general/js/hooks/useScreenDetector';
import { getImageSrc, redirectTo } from '../../../general/js/utils';
import Oauth from '../../sso/components/oauth';

const ModalTriggerPromoPanelWrapper = (props) => {
    const [ currentUser, setCurrentUser ] = useState(null);
    const { isMobile, isTablet } = useScreenDetector();

    useEffect(() => {
        Oauth.getCurrentAuthenticatedUser()
            .then((user) => {
                setCurrentUser(user);
            })
            .catch(() => {
                return;
            });
    }, []);

    if (hasValue(currentUser)) {
        redirectTo('account/profile');
    }

    const {
        image,
        tabletImage,
        mobileImage,
        heading,
        subHeading,
        ctaButtonLabel,
        ctaButtonActionResource,
        desktopImageOpacity,
        mobileImageOpacity
    } = props;

    const mobileOpacity = isMobile && mobileImageOpacity && mobileImageOpacity !== 0 ? mobileImageOpacity : undefined;
    const imageOpacity = !isMobile && desktopImageOpacity && desktopImageOpacity !== 0 ? desktopImageOpacity : undefined;

    const imgStyle = imageOpacity || mobileOpacity ? {
        opacity: imageOpacity || mobileOpacity
        } :
        undefined;

    const imageSrc = isMobile ? getImageSrc(mobileImage) : 
        isTablet ? getImageSrc(tabletImage) : getImageSrc(image)

    return (
        <section className="modal-trigger-promo-panel mastercard-success">
            <div className="modal-trigger-promo-panel__wrap">
                <div className="modal-trigger-promo-panel__media">
                    <div className="modal-trigger-promo-panel__media--wrapper">
                        {
                            hasValue(imageSrc) &&
                            <img className="modal-trigger-promo-panel__media--backgroundImage" height="720" width="1280" src={imageSrc} alt="" style={imgStyle} />
                        }
                    </div>
                </div>
                <div className="modal-trigger-promo-panel__content">
                    <div className="modal-trigger-promo-panel__wrapper">
                        <div className="modal-trigger-promo-panel__tag">{heading}</div>
                        <div className="modal-trigger-promo-panel__heading">
                            <h2 className="modal-trigger-promo-panel__title">{subHeading}</h2>
                        </div>
                        <div className="modal-trigger-promo-panel__form">
                            <div className="modal-trigger-promo-panel__form--row">
                                <a className="button button--primary" data-dc-component="modal-trigger-login"
                                    href={ctaButtonActionResource}
                                    data-dc-modal-trigger-login-failed-return-url-param="@QueryParameters.LoginFailedReturnUrl">
                                    <span>{ctaButtonLabel}</span>
                                </a></div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}

ModalTriggerPromoPanelWrapper.propTypes = {
    image: PropTypes.object,
    heading: PropTypes.string,
    subHeading: PropTypes.string,
    ctaButtonLabel: PropTypes.string,
    ctaButtonActionResource: PropTypes.string
};

export default ModalTriggerPromoPanelWrapper;
